class BracketingNudge extends HTMLElement {
  constructor() {
    super();
    this.checkBracketing = this.checkBracketing.bind(this);
  }

  connectedCallback() {
    // Check on initial load with a slight delay to ensure DOM is ready
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', () => {
        setTimeout(this.checkBracketing, 200);
      });
    } else {
      setTimeout(this.checkBracketing, 200);
    }

    // Listen for cart updates
    document.addEventListener('cart:updated', this.checkBracketing);
    document.addEventListener('cart:check-bracketing', this.checkBracketing);
    
    // Also check when cart drawer is opened
    document.addEventListener('cartdrawer:opened', this.checkBracketing);
  }

  disconnectedCallback() {
    document.removeEventListener('cart:updated', this.checkBracketing);
    document.removeEventListener('cart:check-bracketing', this.checkBracketing);
    document.removeEventListener('cartdrawer:opened', this.checkBracketing);
  }

  checkBracketing() {
    // Use setTimeout to ensure DOM is updated after cart changes
    setTimeout(() => {
      // Get all cart items - try multiple selectors to handle different cart states
      const cartItemsContainer = document.querySelector('cart-items');
      if (!cartItemsContainer) {
        this.classList.add('hidden');
        return;
      }

      const cartItems = cartItemsContainer.querySelectorAll('.mini-cart__navigation > li[data-handle]');
      
      if (cartItems.length < 2) {
        this.classList.add('hidden');
        return;
      }

      // Convert NodeList to Array for easier manipulation
      const itemsArray = Array.from(cartItems);

      // Check for adjacent items with same product handle but different sizes
      let foundBracketing = false;

      for (let i = 0; i < itemsArray.length - 1; i++) {
        const currentItem = itemsArray[i];
        const nextItem = itemsArray[i + 1];

        const currentHandle = currentItem.getAttribute('data-handle');
        const nextHandle = nextItem.getAttribute('data-handle');
        const currentSize = currentItem.getAttribute('data-size') || '';
        const nextSize = nextItem.getAttribute('data-size') || '';

        // Check if same product (handle) and different sizes
        if (currentHandle && nextHandle && 
            currentHandle === nextHandle && 
            currentSize && 
            nextSize && 
            currentSize !== nextSize) {
          foundBracketing = true;
          break;
        }
      }

      // Show or hide nudge based on detection
      if (foundBracketing) {
        this.classList.remove('hidden');
      } else {
        this.classList.add('hidden');
      }
    }, 100);
  }
}

customElements.define('bracketing-nudge', BracketingNudge);

